// extracted by mini-css-extract-plugin
export default {"dropdown":"TVCardDropdown_dropdown__Mxmzl","element":"TVCardDropdown_element__k6EW1","icon":"TVCardDropdown_icon__sSSkb","saved":"TVCardDropdown_saved__3kn8B"};